const handler = ( $ ) => {
	const $searchButton = $( '.header__top-search button' );
	const $searchModal = $( '.search-modal' );
	const $searchModalContainer = $( '.search-modal__container' );
	const $overlay = $( '.site-overlay' );
	const $body = $( 'body' );

	// Modal search form elements
	const $searchForm = $( '#modal-search-form' );
	const $searchField = $searchForm.find( '.search-field' );
	const $validationMessage = $searchForm.find( '.search-validation-message' );

	// Mobile search form elements
	const $mobileSearchForm = $( '#mobile-search-form' );
	const $mobileSearchField = $mobileSearchForm.find( '.search-field' );
	const $mobileValidationMessage = $mobileSearchForm.find(
		'.search-validation-message'
	);

	// Main search form elements
	const $mainSearchForm = $( '#main-search-form' );
	const $mainSearchField = $mainSearchForm.find( '#search' );
	const $mainValidationMessage = $mainSearchForm.find(
		'.search-validation-message'
	);

	let searchModalOpen = false;

	const openModal = () => {
		if ( searchModalOpen ) return;
		$searchModal.css( 'display', 'flex' );
		$overlay.stop( true, true ).fadeIn( 100 );
		$body.addClass( 'freeze' );
		searchModalOpen = true;

		setTimeout( function () {
			$searchModal.find( '.search-field' ).trigger( 'focus' );
		}, 100 );
	};

	const closeModal = () => {
		if ( ! searchModalOpen ) return;
		$searchModal.css( 'display', 'none' );
		$overlay.stop( true, true ).fadeOut( 100 );
		$body.removeClass( 'freeze' );
		searchModalOpen = false;
		$validationMessage.hide();
	};

	$searchButton.on( 'click', function ( e ) {
		e.preventDefault();
		e.stopPropagation();
		if ( $( '.menu-item-has-children.submenu-open' ).length ) return;
		openModal();
	} );

	$( document ).on( 'click', function ( e ) {
		if (
			searchModalOpen &&
			! $( e.target ).closest( '.search-modal' ).length &&
			! $( e.target ).closest( '.header__top-search' ).length
		) {
			closeModal();
		}
	} );

	$searchModal.on( 'click', function ( e ) {
		if ( e.target === this ) closeModal();
	} );

	$searchModalContainer.on( 'click', function ( e ) {
		e.stopPropagation();
	} );

	$overlay.on( 'click', function () {
		closeModal();
	} );

	$( document ).on( 'keydown', function ( e ) {
		if ( e.key === 'Escape' && searchModalOpen ) closeModal();
	} );

	// Form validation for modal search
	$searchForm.on( 'submit', function ( e ) {
		const searchQuery = $searchField.val();
		const searchQueryNoSpaces = searchQuery.replace( /\s+/g, '' );

		if ( searchQueryNoSpaces.length < 3 ) {
			e.preventDefault();
			$validationMessage
				.text(
					'Please enter at least 3 characters (spaces not counted)'
				)
				.show();
			return false;
		}

		$validationMessage.hide();
		return true;
	} );

	$searchField.on( 'input', function () {
		$validationMessage.hide();
	} );

	// Form validation for mobile search
	$mobileSearchForm.on( 'submit', function ( e ) {
		const searchQuery = $mobileSearchField.val();
		const searchQueryNoSpaces = searchQuery.replace( /\s+/g, '' );

		if ( searchQueryNoSpaces.length < 3 ) {
			e.preventDefault();
			$mobileValidationMessage
				.text(
					'Please enter at least 3 characters (spaces not counted)'
				)
				.show();
			return false;
		}

		$mobileValidationMessage.hide();
		return true;
	} );

	$mobileSearchField.on( 'input', function () {
		$mobileValidationMessage.hide();
	} );

	// Form validation for main search
	$mainSearchForm.on( 'submit', function ( e ) {
		const searchQuery = $mainSearchField.val();
		const searchQueryNoSpaces = searchQuery.replace( /\s+/g, '' );

		if ( searchQueryNoSpaces.length < 3 ) {
			e.preventDefault();
			$mainValidationMessage
				.text(
					'Please enter at least 3 characters (spaces not counted)'
				)
				.show();
			return false;
		}

		$mainValidationMessage.hide();
		return true;
	} );

	$mainSearchField.on( 'input', function () {
		$mainValidationMessage.hide();
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
